<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">

            <form action="" class="">
              <div class="row d-flex align-items-end">
                <!-- <div class="col-sm-4 form-group">
                  <label for="">รหัสสมาชิก</label>
                  <b-input name="AgentId" type="text" v-model="values.AgentId" placeholder="รหัสสมาชิก" disabled />
                </div> -->
                <div class="col-sm-12 form-group text-center p-4">
                  <button type="button" class="btn btn-primary shadow" :disabled="isBusy"
                   @click="generateWhtc">
                    <div v-if="!isBusy" class="fe-download p-2 h1 text-white"></div>
                    <div v-else  class="p-3"><b-spinner></b-spinner></div> 
                    สร้างและดาวน์โหลด</button>
                </div>
              </div>
            </form>
            
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>

import Layout from '@/components/layouts/main'
import PageHeader from '@/components/page-header'
import pdfMake from 'pdfmake'
import pdfFonts from '../../assets/custom-fonts.js'
import sklogo from '../../helper/sk_logo.js'

let self;
/**
 * Customers component
 */
export default {
  page: {
    title: 'นายหน้า',
    meta: [{ name: 'description' }],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    var yup = this.yup
    return {
      title: 'หนังสือรับรองการหักภาษี ณ ที่จ่าย (ใบ 50 ทวิ)',
      items: [
        {
          text: 'SKLife',
          to: { name: 'home' }
        },
        {
          text: 'Withholding tax certificate',
          active: true
        },
      ],

      VUE_APP_OFFICEAPI_URL: process.env.VUE_APP_OFFICEAPI_URL,
      isBusy: false,

      DataWhtc50: {},

      YearTh: 0,
      filter: {
        AgentId: "",
        Firstname: "",
        Lastname: "",
      },
      values: {
        RefId: "",
        AgentId: "",
        Firstname: "",
        Lastname: "",
        Status: 0,
        PerPage: 10,
        CurrentPage: 1,
      },
      errors: {
        AgentId: "",
        Firstname: "",
        Lastname: "",
        Status: "",
      },
      FormSchema: yup.object().shape({
        AgentId: yup.string().test('empty-check', 'ค้นหาไม่น้อยกว่า 4 ตัวอักษร', AgentId => !AgentId || AgentId.length >= 4),
        Firstname: yup.string().test('empty-check', 'ค้นหาไม่น้อยกว่า 4 ตัวอักษร', Firstname => !Firstname || Firstname.length >= 4),
        Lastname: yup.string().test('empty-check', 'ค้นหาไม่น้อยกว่า 4 ตัวอักษร', Lastname => !Lastname || Lastname.length >= 4),
      }),
    }
  },
  async created() {
    if (this.$store.state.Admin.IsForceChangePwd)
      this.$router.push({ name: 'admin-change-password' });

    if (!this.$store.state.MenuWhtc50.IsShowMenu)
      this.$router.push({ name: 'home' });

    self = this;
    self.values.RefId = this.$store.state.Admin.RefId;
    self.YearTh = this.$store.state.MenuWhtc50.FiscalYear + 543;

    //console.log(this.$store.state);
    await self.getAgentId();
    //console.log(self.values.AgentId);
  },
  mounted() {
    //self.export();
  },
  methods: {
    generateWhtc() {
      self.export();
      console.log('generateWhtc');
    },
    async getAgentId() {
      this.isBusy = true
      const config = {
        headers: { Authorization: `Bearer ${this.$store.state.Admin.Token}` },
      };
      await this.axios.get(process.env.VUE_APP_OFFICEAPI_URL + '/api/whtc/getagentid/' + self.values.RefId, config)
        .then(function (res) {
          if (res.status == 200) {
            self.values.AgentId = res.data;
          } else {
            self.$swal('เกิดข้อผิดพลาด');
          }
          self.isBusy = false
        })
        .catch(function (error) {
          self.$swal('เกิดข้อผิดพลาด');
          self.isBusy = false
        });
    },
    async getWhtc50() {
      self.isBusy = true;
      const config = {
        headers: { Authorization: `Bearer ${this.$store.state.Admin.Token}` },
      };
      let isSuccess = await this.axios.get(process.env.VUE_APP_OFFICEAPI_URL + `/api/whtc/getwhtc50/${this.$store.state.MenuWhtc50.FiscalYear}/${self.values.AgentId}`, config)
        .then(function (res) {
          if (res.status == 200) {
            self.DataWhtc50 = res.data;
            self.isBusy = false;
            return true;
          } else {
            self.isBusy = false;
            return false;
          }
        })
        .catch(function (error) {
          self.isBusy = false;
          return false;
        });

        self.isBusy = false;
      return isSuccess;
    },

    async export() {
      let yearTh2Digit = self.YearTh.toString().substring(2);
      console.log(yearTh2Digit);
      const date = new Date()
      date.setDate(5);
      date.setMonth(0);
      date.setFullYear(date.getFullYear());
      const dateNowTh = date.toLocaleDateString('th-TH', { year: 'numeric', month: 'long', day: 'numeric', });

      console.log(dateNowTh)

      let isSuccessLoadWhtc50 = await self.getWhtc50();


      console.log(isSuccessLoadWhtc50)
      if (!isSuccessLoadWhtc50)
        return;

      console.log(self.DataWhtc50)

      pdfMake.vfs = pdfFonts.pdfMake.vfs
      pdfMake.fonts = {
        NotoSans: {
          normal: 'NotoSans-Regular.ttf',
          bold: 'NotoSans-Regular.ttf',
          italics: 'NotoSans-Regular.ttf',
          bolditalics: 'NotoSans-Regular.ttf',
        },
        NotoSansThai: {
          normal: 'NotoSansThai-Regular.ttf',
          bold: 'NotoSansThai-Bold.ttf',
          italics: 'NotoSansThai-Regular.ttf',
          bolditalics: 'NotoSansThai-Bold.ttf',
        },
        NotoSansThaiUI: {
          normal: 'NotoSansThaiUI-Regular.ttf',
          bold: 'NotoSansThaiUI-Regular.ttf',
          italics: 'NotoSansThaiUI-Regular.ttf',
          bolditalics: 'NotoSansThaiUI-Regular.ttf',
        },
        Cerebrisans: {
          normal: 'cerebrisans-regular.ttf',
          bold: 'cerebrisans-regular.ttf',
          italics: 'cerebrisans-regular.ttf',
          bolditalics: 'cerebrisans-regular.ttf',
        },
        Fontello: {
          normal: 'fontello.ttf',
          bold: 'fontello.ttf',
          italics: 'fontello.ttf',
          bolditalics: 'fontello.ttf'
        }
      }

      const docDefinition = {
        pageSize: 'A4',
        pageMargins: [30, 40, 30, 30],
        styles: {
          ml1: { margin: [10, 0, 0, 0] },
          ml2: { margin: [20, 0, 0, 0] },
          ml3: { margin: [30, 0, 0, 0] },
          icon: {
            font: 'Fontello',
            fontSize: 12,
          },
          header: {
            fontSize: 18,
            bold: true,
            margin: [0, 0, 0, 10]
          },
          subheader: {
            fontSize: 16,
            bold: true,
            margin: [0, 10, 0, 5]
          },
          tableExample: {
            margin: [0, 0, 0, 0]
          },
          tableMt1: {
            margin: [0, 3, 0, 0]
          },
          tableHeader: {
            bold: true,
            fontSize: 13,
            color: 'black'
          }
        },
        defaultStyle: {
          font: 'NotoSansThai',
          fontSize: 8,
        },
        content: [
          { text: 'ฉบับที่ 1 (สําหรับผู้ถูกหักภาษี ณ ที่ จ่าย ใช้แนบพร้อมกับแบบแสดงรายการภาษี)', fontSize: 6 },
          { text: 'ฉบับที่ 2 (สําหรับผู้ถูกหักภาษี ณ ที่ จ่าย เก็บไว้เป็นหลักฐาน SKL)', fontSize: 6 },

          {
            //layout: 'lightHorizontalLines', // optional
            style: 'tableExample',
            table: {
              headerRows: 0,
              widths: ['*'],
              heights: [740],
              body: [
                [
                  {
                    stack: [
                      {
                        border: true,
                        columns: [
                          { text: 'หนังสือรับรองการหักภาษี ณ ที่จ่าย', alignment: 'center', width: '*', bold: false, margin: [100, 0, 0, 0], fontSize: 10 },
                          { text: 'เลขที่ SKL ' + yearTh2Digit + this.$store.state.Admin.Id, alignment: 'right', width: 150, bold: false, fontSize: 10 },
                        ]
                      },
                      {
                        columns: [
                          { text: 'ตามมาตรา 50 ทวิ แห่งประมวลรัษฎากร', alignment: 'center', width: '*', fontSize: 8, margin: [100, 0, 0, 0] },
                          { text: '', alignment: 'right', width: 150, fontSize: 8 },
                        ]
                      },
                      {
                        style: 'tableExample',
                        table: {

                          widths: ['*'],
                          body: [
                            [{
                              stack: [
                                {
                                  columns: [
                                    { text: 'ผู้มีหน้าที่หักภาษี ณ ที่ จ่าย :-', width: '*' },
                                    { text: 'เลขประจําตัวประชาชน', width: '30%' }
                                  ]
                                },
                                {
                                  columns: [
                                    { text: 'ชื่อ', width: 20 },
                                    {
                                      stack: [
                                        { text: 'บริษัท ศรีกรุงประกันชีวิตโบรคเกอร์ จํากัด (สํานักงานใหญ่)', width: '*', color: '#777777'/*decoration: 'underline'*/ },
                                        {
                                          canvas: [
                                            {
                                              type: 'line',
                                              x1: 0, y1: 0,
                                              x2: 335, y2: 0,
                                              lineWidth: 1,
                                              color: '#777777'
                                            },
                                          ]
                                        },
                                      ]
                                    },
                                    { text: 'เลขประจําตัวผู้เสียภาษีอากร 0105553117436', width: '30%' },
                                  ]
                                },
                                {
                                  columns: [
                                    { text: '', width: 20 },
                                    { text: '(ให้ระบุว่าเป็น บุคคล นิติบุคคล บริษัท สมาคม หรือคณะบุคคล)', width: '70%', fontSize: 6, alignment: 'left' },
                                    { text: '(ให้กรอกเฉพาะผู้ไม่มีเลขประจําตัวประชาชน)', width: '*', fontSize: 6, alignment: 'right' },
                                  ]
                                },
                                {
                                  columns: [
                                    { text: 'ที่อยู่', width: 20 },
                                    {
                                      stack: [
                                        { text: '46/8 อาคารรุ่งโรจน์ธนกุล B ชั้น 11 ถนนรัชดาภิเษก แขวงห้วยขวาง เขตห้วยขวาง กรุงเทพฯ 10310', width: '*', color: '#777777' },
                                        {
                                          canvas: [
                                            {
                                              type: 'line',
                                              x1: 0, y1: 0,
                                              x2: 490, y2: 0,
                                              lineWidth: 1,
                                              color: '#777777'
                                            },
                                          ]
                                        }
                                      ]
                                    }
                                  ]
                                },
                                {
                                  columns: [
                                    { text: '', width: 20 },
                                    { text: '(ให้ระบุ ชื่ออาคาร/หมู่บ้าน ห้องเลขที่ ชั้นที่ เลขที่ ตรอก/ซอย หมู่ที่ ถนน ตําบล/แขวง อําเภอ/เขต จังหวัด)', width: '70%', fontSize: 6, alignment: 'left' },
                                  ]
                                }
                              ]
                            }],
                          ]
                        }
                      },
                      {
                        style: 'tableMt1',
                        table: {
                          widths: ['*'],
                          body: [
                            [{
                              stack: [
                                {
                                  columns: [
                                    { text: 'ผู้ถูกหักภาษี ณ ที่ จ่าย :-', width: '*' },
                                    { text: 'เลขประจําตัวประชาชน ', width: '30%' }
                                  ]
                                },
                                {
                                  columns: [
                                    { text: 'ชื่อ', width: 20 },
                                    {
                                      stack: [
                                        { text: `คุณ${self.DataWhtc50.Firstname} ${self.DataWhtc50.Lastname}`, width: '*', color: '#777777'/*, decoration: 'underline'*/ },
                                        {
                                          canvas: [
                                            {
                                              type: 'line',
                                              x1: 0, y1: 0,
                                              x2: 335, y2: 0,
                                              lineWidth: 1,
                                              color: '#777777'
                                            },
                                          ]
                                        }
                                      ]
                                    },
                                    { text: 'เลขประจําตัวผู้เสียภาษีอากร ' + self.DataWhtc50.CitizenId, width: '30%' },
                                  ]
                                },
                                {
                                  columns: [
                                    { text: '', width: 20 },
                                    { text: '(ให้ระบุว่าเป็น บุคคล นิติบุคคล บริษัท สมาคม หรือคณะบุคคล)', width: '70%', fontSize: 6, alignment: 'left' },
                                    { text: '(ให้กรอกเฉพาะผู้ไม่มีเลขประจําตัวประชาชน)', width: '*', fontSize: 6, alignment: 'right' },
                                  ]
                                },
                                {
                                  columns: [
                                    { text: 'ที่อยู่', width: 20 },
                                    {
                                      stack: [
                                        { text: self.DataWhtc50.AddressFull, width: '*', color: '#777777'/*, decoration: 'underline'*/ },
                                        {
                                          canvas: [
                                            {
                                              type: 'line',
                                              x1: 0, y1: 0,
                                              x2: 490, y2: 0,
                                              lineWidth: 1,
                                              color: '#777777'
                                            },
                                          ]
                                        }
                                      ]
                                    },
                                  ]
                                },
                                {
                                  columns: [
                                    { text: '', width: 20 },
                                    { text: '(ให้ระบุ ชื่ออาคาร/หมู่บ้าน ห้องเลขที่ ชั้นที่ เลขที่ ตรอก/ซอย หมู่ที่ ถนน ตําบล/แขวง อําเภอ/เขต จังหวัด)', width: '70%', fontSize: 6, alignment: 'left' },
                                  ]
                                },
                                {
                                  margin: [0, 5],
                                  columns: [
                                    { text: 'ลำดับที่', width: 30 },
                                    { text: '', width: 100, fontSize: 6, alignment: 'left' },
                                    { text: 'แนบใน', width: 80 },
                                    { text: '', width: 20, style: 'icon' },
                                    { text: '(1) ภ.ง.ด.1ก', width: 50 },
                                    { text: '', width: 20, style: 'icon' },
                                    { text: '(2) ภ.ง.ด.1ก พิเศษ', width: 70 },
                                    { text: '', width: 20, style: 'icon' },
                                    { text: '(3) ภ.ง.ด.2', width: 50 },
                                    { text: '', width: 20, style: 'icon' },
                                    { text: '(4) ภ.ง.ด.3', width: 50 },
                                  ]
                                },
                                {
                                  columns: [
                                    { text: '(ให้สามารถอ้างอิงหรือสอบยันกันได้ระหว่างลําดับที่ตามหนังสือรับรองฯ กับแบบยื่นรายการภาษีหักที่จ่าย)', width: 210, fontSize: 6, alignment: 'left' },
                                    { text: '', width: 20, style: 'icon' },
                                    { text: '(5) ภ.ง.ด.2ก', width: 50 },
                                    { text: '', width: 20, style: 'icon' },
                                    { text: '(6) ภ.ง.ด.3ก', width: 70 },
                                    { text: '', width: 20, style: 'icon' },
                                    { text: '(7) ภ.ง.ด.53', width: 50 },
                                  ]
                                }
                              ]
                            }]
                          ]
                        }
                      },
                      {
                        style: 'tableMt1',
                        layout: {
                          hLineWidth: function (i, node) {
                            return (i <= 1 || i === node.table.body.length || i >= node.table.body.length - 2) ? 1 : .3;
                          },
                          vLineWidth: function (i, node) {
                            return (i <= 1 || i === node.table.widths.length || i >= node.table.widths.length - 2) ? 1 : .3;
                          },
                          hLineColor: function (i, node) {
                            return (i <= 1 || i === node.table.body.length || i >= node.table.body.length - 2) ? 'black' : 'silver';
                          },
                          vLineColor: function (i, node) {
                            return (i <= 1 || i === node.table.widths.length || i >= node.table.widths.length - 2) ? 'black' : 'silver';
                          },
                        },
                        table: {
                          widths: ['*', 55, 55, 55],
                          body: [
                            [
                              { text: 'ประเภทเงินได้พึงประเมินที่จ่าย', alignment: 'center' },
                              { text: 'วัน เดือน หรือปีภาษี ที่ จ่าย', alignment: 'center' },
                              { text: 'จํานวนเงินที่จ่าย', alignment: 'center' },
                              { text: 'ภาษีที่หัก\nและนําส่งไว้', alignment: 'center' },
                            ],
                            [
                              { text: '1. เงินเดือน ค่าจ้าง เบี้ยเลี้ยง โบนัส ฯลฯ ตามมาตรา 40 (1)', alignment: 'left', border: [true, false, true, false], },
                              { text: '', alignment: 'center', border: [true, false, true, true] },
                              { text: '', alignment: 'right', border: [true, false, true, true] },
                              { text: '', alignment: 'right', border: [true, false, true, true] },
                            ],
                            [
                              { text: '2. ค่าธรรมเนียม ค่านายหน้า ฯลฯ ตามมาตรา 40 (2)', alignment: 'left', border: [true, false, true, false], },
                              { text: this.YearTh, alignment: 'center', border: [true, false, true, true] },
                              { text: self.moneyFormatFull(self.DataWhtc50.CommTotal), alignment: 'right', border: [true, false, true, true] },
                              { text: '-', alignment: 'center', border: [true, false, true, true] },
                            ],
                            [
                              { text: '3. ค่าแห่งลิขสิทธิ์ ฯลฯ ตามมาตรา 40 (3)', alignment: 'left', border: [true, false, true, false], },
                              { text: '', alignment: 'center', border: [true, false, true, true] },
                              { text: '', alignment: 'right', border: [true, false, true, true] },
                              { text: '', alignment: 'right', border: [true, false, true, true] },
                            ],
                            [
                              { text: '4. (ก) ดอกเบี้ย ฯลฯ ตามมาตรา 40 (4) (ก)', alignment: 'left', border: [true, false, true, false], },
                              { text: '', alignment: 'center', border: [true, false, true, true] },
                              { text: '', alignment: 'right', border: [true, false, true, true] },
                              { text: '', alignment: 'right', border: [true, false, true, true] },
                            ],
                            [
                              { text: '(ข) เงินปันผล เงินส่วนแบ่งกําไร ฯลฯ ตามมาตรา 40 (4) (ข)', alignment: 'left', style: 'ml1', border: [true, false, true, false], },
                              { text: '', alignment: 'center', border: [true, false, true, false] },
                              { text: '', alignment: 'right', border: [true, false, true, false] },
                              { text: '', alignment: 'right', border: [true, false, true, false] },
                            ],
                            [
                              { text: '(1) กรณีผู้ได้รับเงินปันผลได้รับเครดิตภาษี โดยจ่ายจาก', alignment: 'left', style: 'ml2', border: [true, false, true, false], },
                              { text: '', alignment: 'center', border: [true, false, true, false] },
                              { text: '', alignment: 'right', border: [true, false, true, false] },
                              { text: '', alignment: 'right', border: [true, false, true, false] },
                            ],
                            [
                              { text: 'กําไรสุทธิของกิจการที่ต้องเสียภาษีเงินได้นิติบุคคลในอัตราดังนี้', alignment: 'left', style: 'ml3', border: [true, false, true, false], },
                              { text: '', alignment: 'center', border: [true, false, true, false] },
                              { text: '', alignment: 'right', border: [true, false, true, false] },
                              { text: '', alignment: 'right', border: [true, false, true, false] },
                            ],
                            [
                              { text: '(1.1) อัตราร้อยละ 30 ของกําไรสุทธิ', alignment: 'left', style: 'ml3', border: [true, false, true, false], },
                              { text: '', alignment: 'center', border: [true, false, true, true] },
                              { text: '', alignment: 'right', border: [true, false, true, true] },
                              { text: '', alignment: 'right', border: [true, false, true, true] },
                            ],
                            [
                              { text: '(1.2) อัตราร้อยละ 25 ของกําไรสุทธิ', alignment: 'left', style: 'ml3', border: [true, false, true, false], },
                              { text: '', alignment: 'center', border: [true, false, true, true] },
                              { text: '', alignment: 'right', border: [true, false, true, true] },
                              { text: '', alignment: 'right', border: [true, false, true, true] },
                            ],
                            [
                              { text: '(1.3) อัตราร้อยละ 20 ของกําไรสุทธิ', alignment: 'left', style: 'ml3', border: [true, false, true, false], },
                              { text: '', alignment: 'center', border: [true, false, true, true] },
                              { text: '', alignment: 'right', border: [true, false, true, true] },
                              { text: '', alignment: 'right', border: [true, false, true, true] },
                            ],
                            [
                              { text: '(1.3) อัตราอื่นๆ (ระบุ)________________ของกําไรสุทธิ', alignment: 'left', style: 'ml3', border: [true, false, true, false], },
                              { text: '', alignment: 'center', border: [true, false, true, true] },
                              { text: '', alignment: 'right', border: [true, false, true, true] },
                              { text: '', alignment: 'right', border: [true, false, true, true] },
                            ],
                            [
                              { text: '(2) กรณีผู้ได้รับเงินปันผลไม่ได้รับเครดิตภาษี เนื่องจากจ่ายจาก', alignment: 'left', style: 'ml2', border: [true, false, true, false], },
                              { text: '', alignment: 'center', border: [true, false, true, false] },
                              { text: '', alignment: 'right', border: [true, false, true, false] },
                              { text: '', alignment: 'right', border: [true, false, true, false] },
                            ],
                            [
                              { text: '(2.1) กําไรสุทธิของกิจการที่ได้รับยกเว้นภาษีเงินได้นิติบุคคล', alignment: 'left', style: 'ml3', border: [true, false, true, false], },
                              { text: '', alignment: 'center', border: [true, false, true, true] },
                              { text: '', alignment: 'right', border: [true, false, true, true] },
                              { text: '', alignment: 'right', border: [true, false, true, true] },
                            ],
                            [
                              { text: '(2.2) เงินปันผลหรือเงินส่วนแบ่งของกําไรที่ได้รับยกเว้นไม่ต้องนํามารวม คํานวณเป็นรายได้เพื่อเสียภาษีเงินได้นิติบุคคล', alignment: 'left', style: 'ml3', border: [true, false, true, false], },
                              { text: '', alignment: 'center', border: [true, false, true, true] },
                              { text: '', alignment: 'right', border: [true, false, true, true] },
                              { text: '', alignment: 'right', border: [true, false, true, true] },
                            ],
                            [
                              { text: '(2.3) กําไรสุทธิส่วนที่ได้หักผลขาดทุนสุทธิยกมาไม่เกิน 5 ปี ก่อนรอบระยะเวลาบัญชีปัจจุบัน', alignment: 'left', style: 'ml3', border: [true, false, true, false], },
                              { text: '', alignment: 'center', border: [true, false, true, true] },
                              { text: '', alignment: 'right', border: [true, false, true, true] },
                              { text: '', alignment: 'right', border: [true, false, true, true] },
                            ],
                            [
                              { text: '(2.4) กําไรที่รับรู้ทางบัญชีโดยวิธีส่วนได้ส่วนเสีย (equity method)', alignment: 'left', style: 'ml3', border: [true, false, true, false], },
                              { text: '', alignment: 'center', border: [true, false, true, true] },
                              { text: '', alignment: 'right', border: [true, false, true, true] },
                              { text: '', alignment: 'right', border: [true, false, true, true] },
                            ],
                            [
                              { text: '(2.5) อื่นๆ (ระบุ)', alignment: 'left', style: 'ml3', border: [true, false, true, false], },
                              { text: '', alignment: 'center', border: [true, false, true, true] },
                              { text: '', alignment: 'right', border: [true, false, true, true] },
                              { text: '', alignment: 'right', border: [true, false, true, true] },
                            ],
                            [
                              { text: '5. การจ่ายเงินได้ที่ต้องหักภาษี ณ ที่จ่าย ตามคําสั่งกรมสรรพากรที่ออกตามมาตรา 3 เตรส (ระบุ) \n___________________________________________ ', alignment: 'left', border: [true, false, true, false], },
                              { text: '', alignment: 'center', border: [true, false, true, true] },
                              { text: '', alignment: 'right', border: [true, false, true, true] },
                              { text: '', alignment: 'right', border: [true, false, true, true] },
                            ],
                            [
                              { text: '(เช่น รางวัล ส่วนลดหรือประโยชน์ใดๆ เนืϧองจากการส่งเสริมการขาย รางวัลในการประกวด การแข่งขัน การชิงโชค ค่าแสดงของนักแสดงสาธารณะ ค่าจ้างทําของ ค่าโฆษณา ค่าเช่า ค่าขนส่ง ค่าบริการ ค่าเบี้ยประกันวินาศภัย ฯลฯ)', alignment: 'left', fontSize: 6, border: [true, false, true, false], },
                              { text: '', alignment: 'center', border: [true, false, true, true] },
                              { text: '', alignment: 'right', border: [true, false, true, true] },
                              { text: '', alignment: 'right', border: [true, false, true, true] },
                            ],
                            [
                              { text: '6. อื่นๆ (ระบุ)', alignment: 'left', border: [true, false, true, true], },
                              { text: '', alignment: 'center', border: [true, false, true, true] },
                              { text: '', alignment: 'right', border: [true, false, true, true] },
                              { text: '', alignment: 'right', border: [true, false, true, true] },
                            ],
                            [
                              { text: 'รวมเงินที่จ่ายและภาษีที่หักนําส่ง', alignment: 'right', border: [true, false, true, false], colSpan: 2 },
                              { text: '', alignment: 'center', border: [true, false, true, true] },
                              { text: self.moneyFormatFull(self.DataWhtc50.CommTotal), alignment: 'right', border: [true, false, true, true] },
                              { text: '-', alignment: 'center', border: [true, false, true, true] },
                            ],
                            [
                              { text: 'รวมเงินภาษีที่หักนําส่ง (ตัวอักษร)', alignment: 'left', border: [true, false, false, true] },
                              { text: 'ศูนย์บาทถ้วน', alignment: 'center', border: [false, false, true, true], colSpan: 3 },
                              { text: '', alignment: 'right', border: [true, false, true, true] },
                              { text: '', alignment: 'right', border: [true, false, true, true] },
                            ],
                          ]
                        }
                      },
                      {
                        style: 'tableMt1',
                        table: {
                          widths: ['*'],
                          body: [
                            [{ text: 'เงินที่จ่ายเข้ากบข./กสจ./กองทุนสงเคราะห์ครูโรงเรียนเอกชน .................. บาท กองทุนประกันสังคม ................... บาท กองทุนสํารองเลี้ยงชีพ ................. บาท', alignment: 'center' }]
                          ]
                        }
                      },
                      {
                        style: 'tableMt1',
                        table: {
                          widths: ['*'],
                          body: [
                            [
                              {
                                columns: [
                                  { text: 'ผู้จ่ายเงิน', width: 70 },
                                  { text: '', width: 20, style: 'icon' },
                                  { text: '(1) หัก ณ.ที่จ่าย', width: 70 },
                                  { text: '', width: 20, style: 'icon' },
                                  { text: '(2) ออกให้ตลอดไป', width: 70 },
                                  { text: '', width: 20, style: 'icon' },
                                  { text: '(3) ออกให้ครั้งเดียว', width: 70 },
                                  { text: '', width: 20, style: 'icon' },
                                  { text: '(4) อื่นๆ (ระบุ)', width: 70 },
                                ]
                              }
                            ]
                          ]
                        }
                      },
                      {
                        style: 'tableMt1',
                        table: {
                          widths: ['40%', '60%'],
                          heights: [70],
                          body: [
                            [
                              {
                                margin: [0, 10, 0, 0],
                                columns: [
                                  { text: 'คําเตือน', width: 30 },
                                  { text: 'ผู้มีหน้าที่ออกหนังสือรับรองการหักภาษี ณ ที่จ่าย ฝ่าฝืนไม่ปฏิบัติตามมาตรา 50 ทวิ แห่งประมวล รัษฎากร ต้องรับโทษทางอาญาตามมาตรา 35 แห่งประมวลรัษฎากร', alignment: 'left' },
                                ]
                              },
                              {
                                margin: [0, 10, 0, 0],
                                stack: [
                                  { text: 'ขอรับรองว่าข้อความและตัวเลขดังกล่าวข้างต้นถูกต้องตรงกับความจริงทุกประการ', alignment: 'center' },
                                  { text: 'ลงชื่อ ...................... สุรศักดิ์ แก้วสำลี ................. ผู้จ่ายเงิน', alignment: 'center' },
                                  { text: '.....................' + dateNowTh + '.....................', alignment: 'center' },
                                  { text: '(วัน เดือน ปี ที่ออกหนังสือรับรองฯ)', alignment: 'center' },

                                ]
                              },


                            ]
                          ]
                        }
                      },
                    ]
                  },

                ],
              ]
            }
          },
          {
            image: sklogo
            , width: 80
            , height: 80
            , absolutePosition: { x: 480, y: 720 },
          },
        ]
      }

      //pdfMake.createPdf(docDefinition).open({}, window)
      pdfMake.createPdf(docDefinition).download(`SKL_50ทวิ_${self.YearTh}_${self.values.AgentId}.pdf`)

    },


  }
}
</script>

